<template>
  <div :class="[...computedClasses, $attrs.class].filter(Boolean)">
    <p>
      <slot />
    </p>
  </div>
</template>

<script setup lang="ts">
import {
  computed, defineProps, defineOptions, PropType,
} from 'vue';

defineOptions({
  inheritAttrs: false,
});

// Props
const props = defineProps({
  type: {
    type: String as PropType<'p' | 'span'>,
    default: 'p',
  },
  color: {
    type: String as PropType<'gray' | 'white' | 'primary'>,
    default: 'gray',
  },
  size: {
    type: String as PropType<'base' | 'lg' | 'xl' | '2xl'>,
    default: 'base',
  },
  align: {
    type: String as PropType<'left' | 'center' | 'right'>,
    default: 'center',
  },
  animation: {
    type: String as PropType<'fadeIn' | 'slideDown' | 'slideUp' | 'slideLeft' | 'slideRight'>,
    default: 'fadeIn',
  },
});

// Data
const colorClasses = {
  gray: 'text-gray-500 dark:text-white',
  white: 'text-white',
  primary: 'text-primary',
};

const sizeClasses = {
  base: 'text-base',
  lg: 'text-lg sm:text-xl/8',
  xl: 'text-xl sm:text-2xl',
  '2xl': 'text-2xl sm:text-3xl',
};

const alignClasses = {
  left: 'text-left',
  center: 'text-center',
  right: 'text-right',
};

const animationClasses = {
  fadeIn: 'animate-fade-in',
  slideDown: 'animate-slide-down',
  slideUp: 'animate-slide-up',
  slideLeft: 'animate-slide-left',
  slideRight: 'animate-slide-right',
};

// Merge all class sources
const computedClasses = computed(() => [
  'text-pretty',
  colorClasses[props.color],
  sizeClasses[props.size],
  alignClasses[props.align],
  animationClasses[props.animation],
]);
</script>
